export default __webpack_public_path__ + "static/logo-riga-b81f26489e419177f3c035701f235425.png";